(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/index.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/index.js');
"use strict";


const Redeem = _ref => {
  let voucherData = _ref.voucherData,
    campaign = _ref.campaign,
    history = _ref.history,
    match = _ref.match,
    isPlayer = _ref.isPlayer,
    numberOfTickets = _ref.numberOfTickets,
    totalPrice = _ref.totalPrice;
  const AuthorizedLanding = svs.ticket_gifts.redeem.components.AuthorizedLanding;
  const UnauthorizedLanding = svs.ticket_gifts.redeem.components.UnauthorizedLanding;
  const _svs$ticket_gifts$uti = svs.ticket_gifts.utils.campaign.ids,
    _svs$ticket_gifts$uti2 = _svs$ticket_gifts$uti === void 0 ? {} : _svs$ticket_gifts$uti,
    LYCKOPLATSEN = _svs$ticket_gifts$uti2.LYCKOPLATSEN;
  React.useEffect(() => {
    if (campaign !== LYCKOPLATSEN && !svs.utils.url.queryString.koder && isPlayer && history.location.search) {
      history.replace(history.location.pathname, history.location.pathname);
    }
  }, [history, isPlayer]);
  return isPlayer ? React.createElement(AuthorizedLanding, {
    campaign: campaign,
    history: history,
    match: match,
    voucherData: voucherData
  }) : React.createElement(UnauthorizedLanding, {
    campaign: campaign,
    history: history,
    numberOfTickets: numberOfTickets,
    totalPrice: totalPrice
  });
};
setGlobal('svs.ticket_gifts.redeem.components.Redeem', Redeem);

 })(window);